const CHANGE_PASSWORD = "/user/change_password";

export const changePassword = { CHANGE_PASSWORD };
